import { render, staticRenderFns } from "./SettingsIndexes.vue?vue&type=template&id=5e6f04a5&scoped=true"
import script from "./SettingsIndexes.vue?vue&type=script&lang=js"
export * from "./SettingsIndexes.vue?vue&type=script&lang=js"
import style0 from "./SettingsIndexes.vue?vue&type=style&index=0&id=5e6f04a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6f04a5",
  null
  
)

export default component.exports